import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from '../Card';
import Button from '../Button';
import { getPendingPostsCount } from '../../lib/api';

export default function ApproveCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { workspaceSlug } = useParams<{ workspaceSlug: string }>();
  const [pendingCount, setPendingCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchCount() {
      setIsLoading(true);
      const count = await getPendingPostsCount();
      setPendingCount(count);
      setIsLoading(false);
    }
    fetchCount();
  }, []);

  return (
    <Card className="relative">
      {/* Badge with count (top-right) */}
      {!isLoading && pendingCount > 0 && (
        <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-red-500 border-2 border-black dark:border-white flex items-center justify-center">
          <span className="text-white font-bold text-sm">
            {pendingCount > 99 ? '99+' : pendingCount}
          </span>
        </div>
      )}

      {/* Content */}
      <h2 className="text-2xl font-bold mb-2 dark:text-gray-100 pr-12">
        {t('dashboard.approve.title')}
      </h2>
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        {isLoading
          ? t('dashboard.approve.loading')
          : t('dashboard.approve.description', { count: pendingCount })}
      </p>

      {/* CTA Button */}
      <Button
        variant="secondary"
        onClick={() => navigate(`/${workspaceSlug}/approve`)}
        disabled={isLoading}
        className="w-full sm:w-auto"
      >
        {t('dashboard.approve.button')}
      </Button>
    </Card>
  );
}
